import React from "react";

const Loader = ({ color }) => {
  return (
    <div className=" flex justify-center items-center w-full ">
      <div
        style={{ borderTopColor: color ? color : "#0B28AC" }}
        className="animate-spin  ease-linear rounded-full border-4  border-gray-200 h-12 w-12"
      ></div>
    </div>
  );
};

export default Loader;
